/* eslint-disable max-len */
import React from 'react';
import { Menu } from '../../ui';
import { Checkbox } from '../../ui/Checkbox';
import { Flexer } from '../dashboard/elements/LayoutElements';
import { Avatar } from './Avatar';
import { AvatarStripItem, AvatarStripProps } from './AvatarStrip';

export const AvatarList = <T extends AvatarStripItem>({ items, selected, onSelect }: AvatarStripProps<T>) => {

    const selectedIds = new Set(selected?.map(x => x.id) ?? []);

    const onToggle = (user: T) => {
        onSelect?.(selectedIds.has(user.id) ? selected.filter(x => x.id !== user.id) : [...selected, user]);
    };

    return <Flexer>
        <Menu>
            {items.map(x =>
                <Menu.Item key={x.id} onClick={() => onToggle(x)}>
                    <Avatar
                        key={x.id}
                        size="1.5"
                        name={x.name}
                        photo={x.photo}
                        color={x.color}
                        onClick={() => onToggle(x)}
                    />
                    <Menu.ItemText>{x.name}</Menu.ItemText>
                    <Menu.ItemPush>
                        <Checkbox checked={selectedIds.has(x.id)} />
                    </Menu.ItemPush>
                </Menu.Item>
            )}
        </Menu>
    </Flexer>;
};
